"use strict";

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @ts-ignore

var pure_cache_1 = __importDefault(require("pure-cache"));

var RpcCache = /*#__PURE__*/function () {
  function RpcCache() {
    _classCallCheck(this, RpcCache);

    this.cache = new pure_cache_1.default({
      expiryCheckInterval: 60 * 1000
    });
  }

  _createClass(RpcCache, [{
    key: "getAsset",
    value: function getAsset(assetID, data) {
      if (data) {
        data.mutable_serialized_data = new Uint8Array(data.mutable_serialized_data);
        data.immutable_serialized_data = new Uint8Array(data.immutable_serialized_data);
      }

      return this.access('assets', assetID, data);
    }
  }, {
    key: "deleteAsset",
    value: function deleteAsset(assetID) {
      this.delete('assets', assetID);
    }
  }, {
    key: "getTemplate",
    value: function getTemplate(collectionName, templateID, data) {
      if (data) {
        data.immutable_serialized_data = new Uint8Array(data.immutable_serialized_data);
      }

      return this.access('templates', collectionName + ':' + templateID, data);
    }
  }, {
    key: "deleteTemplate",
    value: function deleteTemplate(collectionName, templateID) {
      this.delete('templates', collectionName + ':' + templateID);
    }
  }, {
    key: "getSchema",
    value: function getSchema(collectionName, schemaName, data) {
      return this.access('schemas', collectionName + ':' + schemaName, data);
    }
  }, {
    key: "deleteSchema",
    value: function deleteSchema(collectionName, schemaName) {
      this.delete('schemas', collectionName + ':' + schemaName);
    }
  }, {
    key: "getCollection",
    value: function getCollection(collectionName, data) {
      return this.access('collections', collectionName, data);
    }
  }, {
    key: "deleteCollection",
    value: function deleteCollection(collectionName) {
      this.delete('collections', collectionName);
    }
  }, {
    key: "getOffer",
    value: function getOffer(offerID, data) {
      return this.access('offers', offerID, data);
    }
  }, {
    key: "deleteOffer",
    value: function deleteOffer(offerID) {
      this.delete('offers', offerID);
    }
  }, {
    key: "access",
    value: function access(namespace, identifier, data) {
      if (typeof data === 'undefined') {
        var cache = this.cache.get(namespace + ':' + identifier);
        return cache === null ? null : cache.value;
      }

      this.cache.put(namespace + ':' + identifier, data, 15 * 60 * 1000);
      return data;
    }
  }, {
    key: "delete",
    value: function _delete(namespace, identifier) {
      this.cache.remove(namespace + ':' + identifier);
    }
  }]);

  return RpcCache;
}();

exports.default = RpcCache;